import gql from 'graphql-tag'

const ClaimsPassengerTicketConnection = gql`
  query ClaimsPassengerTicketConnection($assignAutoComplete: AssignClaimsPassengerTicketFilter! ) {
    claimsPassengerTicketConnection(assignAutoComplete: $assignAutoComplete) {
      edges {
        cursor
        node {
          id
          claimId
          passengerTicketId
          claim {
            id
            crmState
          }
          passengerTicket {
            id
            passengerLastName
            passengerFirstName
            passengerEmail
            airportOrigin {
              name
            }
            airportDestination {
              name
            }
          }
        }
      }
    }
  }
`

export { ClaimsPassengerTicketConnection }


// WEBPACK FOOTER //
// ./src/queries/ClaimsPassengerTicketConnection.js